<section class="reviews">
  <h2 class="reviews__title">{{ 'jecrm_user_reviews' | translate }}</h2>
  <div class="reviews__grid">
    <div class="review-card" *ngFor="let r of reviews">
      <div class="review-card__header">
        <img title="avatar" [src]="r.avatar" alt="avatar" class="review-card__avatar" />
        <div class="review-card__info">
          <div class="review-card__name">{{ r.name | translate }}</div>
          <div class="review-card__category">{{ r.category | translate }}</div>
        </div>
      </div>
      <p class="review-card__text">{{ r.text | translate }}</p>
    </div>
  </div>
</section>
